import { IDocumentFolderModel } from '@api/models';
import DeleteConfirmationDrawer from '@library/drawer/components/DeleteConfirmationDrawer';
import useDeleteFolderForm from 'modules/documents/hooks/useDeleteFolderForm';
import { toast } from 'react-toastify';

interface DeleteFolderDrawerProps {
    clientId: string;
    show: boolean;
    onClose: () => void;
    folder: IDocumentFolderModel;
    onDelete: (folderId: string) => void;
}

const DeleteFolderDrawer = (props: DeleteFolderDrawerProps) => {
    const { show, onClose, folder, onDelete, clientId } = props;

    const deleteFolderForm = useDeleteFolderForm({ clientId, folder });

    const handleDelete = async () => {
        try {
            await deleteFolderForm.submit();

            onDelete(folder._id);

            onClose();

            toast.success('Folder deleted successfully.');
        } catch (err: any) {
            toast.error(err.data?.message || 'Some error occurred, please try again.');

            onClose();
        }
    };

    return (
        <DeleteConfirmationDrawer
            open={show}
            onClose={onClose}
            message={
                <>
                    <div>
                        We will permanently delete the <span className="text-grayscale-900">“{folder?.name}”</span>{' '}
                        folder. All files, external links and subfolders inside this folder will be deleted as well and
                        cannot be recovered.
                    </div>
                    <div className="mt-4">
                        <span className="text-grayscale-900 font-semibold">Attention: </span> This action is
                        irreversible!
                    </div>
                </>
            }
            onConfirm={handleDelete}
            isConfirming={deleteFolderForm.isLoading}
        />
    );
};

export default DeleteFolderDrawer;
